import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateScreenService {
  private isMobileSubject = new BehaviorSubject<boolean>(false);
  mobile$: Observable<boolean> = this.isMobileSubject.asObservable();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([`(min-width: 960px)`])
      .subscribe((result) => {
        this.isMobileSubject.next(!result.matches);
      });
  }
}
